export default __webpack_public_path__ + "static/media/a024-startup-1.aecbfb59.svg";